module.exports = __webpack_public_path__ + "img/google-meet.24429e71.svg";